/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-show-more]');
      if (!btn) return;

      const filterGroup = btn.closest('.filter-group');
      if (!filterGroup) return;

      btn.closest('.collection__sidebar__actions').style.setProperty('display', 'none', 'important');

      const details = filterGroup.querySelector('details');
      const body = details ? details.querySelector('[data-collapsible-body]') : null;

      // If collapsed, open it first, then reveal items after animation completes
      if (details && !details.open) {
        const summary = details.querySelector('summary[data-collapsible-trigger]');
        if (summary) summary.click();
        // Wait for the open animation to finish (500ms matches theme's animation-duration)
        setTimeout(function() {
          revealItems(filterGroup, body);
        }, 550);
      } else {
        // Already open, reveal immediately
        revealItems(filterGroup, body);
      }
    });
  });

  function revealItems(filterGroup, body) {
    filterGroup.querySelectorAll('[data-link-hidden]').forEach(function(link) {
      link.removeAttribute('data-link-hidden');
      link.style.setProperty('display', 'list-item', 'important');
    });
    // Recalculate height after items are revealed
    if (body) body.style.setProperty('height', 'auto', 'important');
  }










  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
